import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './SearchMobileTypeContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { withUser } from '../../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../user/user.types';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

export class RawSearchMobileType extends React.Component<Props> {
  onTypeChange = (selectedType: Props['types'][0]) => () => {
    const { onTypeChanged, accessPremium, openRestrictedModal } = this.props;
    if (accessPremium) {
      onTypeChanged(selectedType.key);
      doctrineAnalytics('Search TypeOfResultChanged', {
        type: selectedType.key,
        source: 'header',
      });
    } else {
      openRestrictedModal('search-types');
    }
  };

  render() {
    const { types, isSearchOpened } = this.props;
    return (
      isSearchOpened && (
        <div className="mobile-search-type">
          <div className="mobile-search-type__wrapper">
            <div className="mobile-search-type__gutter">
              {types.map((type: Props['types'][0], index: number) => (
                <React.Fragment key={type.key}>
                  <a
                    onClick={this.onTypeChange(type)}
                    className={classNames('mobile-search-type__tab', {
                      'mobile-search-type__tab--selected': type.selected,
                    })}
                  >
                    <FormattedMessage id={type.labelId} />
                  </a>
                  {index < types.length && <hr className="hide_on--tablet" />}
                </React.Fragment>
              ))}
            </div>
          </div>
          <span className="mobile-search-type__overlay" />
        </div>
      )
    );
  }
}

export const SearchMobileType = Connect(
  withUser(withRestrictedModal(RawSearchMobileType)),
);
